<template>

  <div>

    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <atenciones-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :estado-filter.sync="estadoFilter"
      :estado-options="estadoOptions"
      :desde-hasta-filter.sync="desdeHastaFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar paciente ..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros coincidentes."
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(usuario)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :variant="`light-${resolveUserServicioVariant(data.item.usuario.perfil.persona.nombres)}`"
                :text="avatarText(data.item.usuario.perfil.persona.nombre_completo)"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.usuario.perfil.persona.nombre_completo }}
            </b-link>
            <small class="text-muted text-monospace py-0">DNI° {{ data.item.usuario.perfil.persona.numero_documento }} - CEL: {{ data.item.usuario.perfil.persona.celular ? data.item.usuario.perfil.persona.celular : '---------' }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.role }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.estado)}`"
            class="text-capitalize"
          >
            {{ data.item.estado }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'salud-atencion-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Atender</span>
            </b-dropdown-item>

            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Archivar</span>
            </b-dropdown-item>

            <!-- <b-dropdown-item
              @click="abrirModal(data.item)"
            >
              <feather-icon icon="ListIcon" />
              <span class="align-middle ml-50">Derivar atención</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando del {{ dataMeta.from }} al {{ dataMeta.to }} de un total de  {{ dataMeta.of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <atencion-derivar :shallShowEmailComposeModal="false" :editedItem="{editedItem}"></atencion-derivar>
  </div>
</template>

<script>
import store from '@/store'
import { avatarText } from '@core/utils/filter'
import { onUnmounted, ref } from '@vue/composition-api'
import {
BAvatar,
BBadge,
BCard,
BCol,
BDropdown, BDropdownItem,
BFormInput,
BLink,
BMedia,
BPagination,
BRow,
BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import AtencionDerivar from "../atenciones-view/AtencionModalDerivar.vue"
import userStoreModule from '../userStoreModule'
import AtencionesListFilters from './AtencionesListFilters.vue'
import UserListAddNew from './UserListAddNew.vue'
import useUsersList from './useUsersList'

export default {
  components: {
    AtencionesListFilters,
    UserListAddNew,
    AtencionDerivar,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  methods: {
    abrirModal(item) {
      const { persona } = item.usuario.perfil;
      console.log(item);
      this.$data.editedItem = {
        id: item.id,
        paciente_id: item.paciente_id,
        nombre_completo: persona.nombre_completo,
        numero_documento: persona.numero_documento,
      }

      this.$bvModal.show('modal_atenciones_paciente')
    },
    abrirModalExamenes() {
      this.$bvModal.show('modal_examenes_medicos')
    }
  },
  data() {
    return {
      editedItem: {}
    }
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-user'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const roleOptions = [
      { id: 1, nombre: 'Medicina General' },
      { id: 2, nombre: 'Odontologia' },
      { id: 3, nombre: 'Oftamologia' },
      { id: 4, nombre: 'Tópico' },
      { id: 5, nombre: 'Gineco-Obstetrico' },
      { id: 6, nombre: 'Psicologia' },
      { id: 7, nombre: 'Enfermería' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const estadoOptions = [
      { label: 'Pendiente', value: 'pendiente' },
      { label: 'Atendido', value: 'completado' },
      { label: 'Archivado', value: 'archivado' },
      { label: 'En Proceso', value: 'en proceso' },
    ]

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      estadoFilter,
      desdeHastaFilter,
    } = useUsersList()
    const resolveUserServicioVariant = val => {
      if (val === 'FARMACIA') return 'primary'
      if (val === 'ODONTOLOGÍA') return 'warning'
      if (val === 'OFTAMOLOGÍA') return 'success'
      if (val === 'TÓPICO') return 'info'
      if (val === 'GINECO-OBSTÉTRICO') return 'danger'
      return 'primary'
    }

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      estadoOptions,
      desdeHastaFilter,

      // Extra Filters
      roleFilter,
      planFilter,
      estadoFilter,

      //
      resolveUserServicioVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
